module.exports = __webpack_public_path__ + "img/xai.49711858.svg";